import { FileType } from 'common/constants';
import { getFileFromXLSX, getBlobObject } from 'hooks/helper';
import { GenerateFileType, GenerateFile } from './types';

const removeSpacesInString = (targetString: string) =>
  targetString.replace(/ /g, '');

export const generateFileForArchive = ({
  content,
  blob,
  fileName,
  fileExtension,
  pdfArchive
}: GenerateFileType): GenerateFile => {
  const fileNameForReport = removeSpacesInString(fileName);
  const fileContent = content
    ? getFileFromXLSX({ content, fileExtension })
    : '';
  const blobObject = blob || getBlobObject({ fileExtension, fileContent });
  const extensionToSend = pdfArchive ? FileType.PDF : fileExtension;
  const file = new File(
    [blobObject],
    `${fileNameForReport}.${String(extensionToSend)}`
  );
  return { file };
};
